import { Paper, Stack } from '@mantine/core';
import { Banner, Switch } from '@repo/foundations';
import { observer } from 'mobx-react-lite';
import type { SearchFilterV2Store } from '../../../components/Filter';
import { FilterBar } from '../../../components/TableV2/Filters/FilterBar';

interface MonitorFilterConfigFormProps {
	store: SearchFilterV2Store;
	matchingMonitorsCount?: number | null;
	matchAll: boolean;
	onMatchAllChange: (value: boolean) => void;
}

export const MonitorFilterConfigForm = observer(
	({
		store,
		matchingMonitorsCount,
		matchAll,
		onMatchAllChange,
	}: MonitorFilterConfigFormProps) => (
		<Paper withBorder p="md" mb="md" radius="md">
			<Stack spacing="md">
				{!matchAll && (
					<FilterBar
						searchFilterV2Store={store}
						filterOptions={store.filterOptions}
					/>
				)}

				{typeof matchingMonitorsCount === 'number' && (
					<Banner
						tone="info"
						message={`${matchingMonitorsCount} monitor${
							matchingMonitorsCount === 1 ? '' : 's'
						} matching rules`}
						inCard
					/>
				)}

				<Switch
					label="Include all Monitors"
					checked={matchAll}
					labelPosition="right"
					onChange={(e) => onMatchAllChange(e.target.checked)}
					description="Apply this rule to all monitors in your workspace"
				/>
			</Stack>
		</Paper>
	)
);
